import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Modal de previsualizacion de un correo antes de enviarlo.
// Hace POST a previewUrl para obtener {ok,to,subject,html,count} SIN enviar, y lo
// muestra en un iframe (fiel al correo real). El correo NO se envia hasta pulsar
// "Enviar", que hace POST a sendUrl. Sirve para revisar antes de mandar (control
// de calidad en produccion) y para probar sin enviar.
//
// Props:
//   titulo      string  - titulo del modal
//   previewUrl  string  - endpoint que devuelve el correo sin enviar
//   sendUrl     string  - endpoint que envia de verdad
//   body        object  - body para ambos POST (ej. {motivo}); opcional
//   enviarLabel string  - texto del boton de envio
//   onClose     fn()
//   onSent      fn()    - se llama tras enviar con exito
export default function PreviewCorreo({ titulo, previewUrl, sendUrl, body = null, enviarLabel = 'Enviar correo', onClose, onSent }) {
  const [cargando, setCargando] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [error, setError]       = useState('');
  const [prev, setPrev]         = useState(null);

  useEffect(() => {
    let activo = true;
    (async () => {
      try {
        const r = await axios.post(previewUrl, body);
        if (activo) { setPrev(r.data); setCargando(false); }
      } catch (e) {
        if (activo) { setError(e.response?.data?.error || e.message); setCargando(false); }
      }
    })();
    return () => { activo = false; };
  }, [previewUrl]); // eslint-disable-line react-hooks/exhaustive-deps

  const enviar = async () => {
    setEnviando(true); setError('');
    try {
      await axios.post(sendUrl, body);
      onSent();
    } catch (e) { setError(e.response?.data?.error || e.message); setEnviando(false); }
  };

  return (
    <div style={ov}>
      <div style={md}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ color: '#012E40', fontSize: 16, fontWeight: 700, margin: 0 }}>{titulo} — vista previa</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#aaa' }}>×</button>
        </div>

        {cargando && <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Generando vista previa...</div>}
        {error && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 }}>{error}</div>}

        {prev && (
          <>
            <div style={{ fontSize: 12, color: '#555', marginBottom: 4 }}><b>Para:</b> {prev.to || '(sin destinatario configurado)'}</div>
            <div style={{ fontSize: 12, color: '#555', marginBottom: 10 }}><b>Asunto:</b> {prev.subject}</div>
            <iframe title="preview-correo" srcDoc={prev.html} sandbox="" style={{ width: '100%', height: '52vh', border: '1px solid #e0e0e0', borderRadius: 8, background: '#fff' }} />
          </>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <button onClick={onClose} disabled={enviando} style={btnSec}>Cancelar</button>
          <button onClick={enviar} disabled={cargando || enviando || !!error} style={{ ...btnPri, opacity: (cargando || enviando || !!error) ? 0.6 : 1 }}>
            {enviando ? 'Enviando...' : enviarLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const ov     = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 20 };
const md     = { background: '#fff', borderRadius: 12, padding: '20px 22px', width: 'min(720px, 96vw)', maxHeight: '92vh', overflow: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' };
const btnSec = { padding: '8px 18px', background: '#fff', color: '#555', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const btnPri = { padding: '8px 20px', background: '#87B749', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' };
